import { getPartnerUrl, getPMISiteUrl } from '../../env-vars';
import styles from './footer.module.scss';
import Logo from '../../../logo.svg';
import PMILogo2 from './pmi-logo2.svg';

function Footer() {
  const myPmiUrl = getPMISiteUrl();
  const myPartnerUrl = getPartnerUrl();

  return (
    <div className={`${styles.customFooter} print-hidden`}>
      <div
        className={`d-flex flex-column flex-sm-row justify-content-between
          ${styles.logoContainer}`}
      >
        <div className={styles.leftLogo}>
          <a href={myPmiUrl} target="_blank" rel="noreferrer">
            <img src={Logo} alt="PMI Logo" />
          </a>
        </div>
        <div className="mt-4 mt-sm-0">
          <img src={PMILogo2} alt="PMI Logo" />
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between text-center">
        <div className="order-2 order-md-1 mt-4 mt-md-0">
          <ul
            className={`d-flex flex-wrap justify-content-center gap-3 ${styles.footerLinks}`}
          >
            <li>
              <a href={`${myPmiUrl}/privacy`} target="_blank" rel="noreferrer">
                Privacy
              </a>
            </li>
            <li>
              <a
                href={`${myPmiUrl}/sitemap-page`}
                target="_blank"
                rel="noreferrer"
              >
                Sitemap
              </a>
            </li>
            <li>
              <a href={`${myPmiUrl}/terms`} target="_blank" rel="noreferrer">
                Terms of Use
              </a>
            </li>
            <li>
              <a
                href={`${myPartnerUrl}/terms`}
                target="_blank"
                rel="noreferrer"
              >
                Partner Platform Terms of Use
              </a>
            </li>
            <li>
              <a
                href={`${myPmiUrl}/about/purchasing-terms-and-conditions`}
                target="_blank"
                rel="noreferrer"
              >
                Purchasing Terms
              </a>
            </li>
            <li>
              <a
                href={`${myPmiUrl}/about/advertising-sponsorship`}
                target="_blank"
                rel="noreferrer"
              >
                Advertising & Sponsorship
              </a>
            </li>
          </ul>
        </div>
        <div
          className={`whitespace-nowrap order-1 order-md-2 text-nowrap mt-4 mt-md-0 ${styles.footerLinks} `}
        >
          © {new Date().getFullYear()} Project Management Institute, Inc.
        </div>
      </div>
    </div>
  );
}

export default Footer;
